module.exports = __webpack_public_path__ + "img/ph-2.f975fa94.jpg";